import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientMedicationsSelector } from '../selectors'
import { setPatientMedicationsList } from '../store/patientMedications.actions'
import { PatientMedicationsConstants } from '../store/patientMedications.constants'
import { IPatientMedicationsState } from '../store/patientMedications.types'

export function* setRoute() {
  const patientMedications: IPatientMedicationsState = yield select(getPatientMedicationsSelector)
  const { route, patientMedication, patientMedicationsList } = patientMedications
  const selectedMedication = patientMedicationsList.filter((medication) => medication.key === patientMedication?.key)
  if (selectedMedication && selectedMedication.length) {
    selectedMedication[0].route = route
    yield put(setPatientMedicationsList(patientMedicationsList))
  }
}
export function* setRouteSaga() {
  yield takeLatest([PatientMedicationsConstants.SET_ROUTE], setRoute)
}
